import { Routes, Route, Navigate } from 'react-router-dom';

import { PrivateRoute, NotAuthorized } from '../_components';
import { Home, Dashboard } from '../_pages/application/dashboard';
import { AccountLayout } from '../_pages/essentials/account';
import { UsersLayout } from '../_pages/application/users';
import { Layout as CustomerLayout } from '../_pages/application/customers';
import { Layout as UserProjectLayout } from '../_pages/application/user_projects';
import { Layout as MasterProfileLayout } from '../_pages/application/master_profiles';
import { Layout as DOLProfileLayout } from '../_pages/application/dol_profiles';
import { Layout as DiscoveryLayout } from '../_pages/application/discovery';
import { Layout as InquiryLayout } from '../_pages/application/inquiry';
import {PageNavigation} from "./PageNavigation";

import React from "react";
import MainGrid from "./common/MainGrid";

export { CustomRoute };

function CustomRoute() {
    return (
        <Routes>
            {/* Private Routes */}
            <Route element={<PrivateRoute />}>
                <Route path="/home" element={<Home />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users/*" element={<UsersLayout />} />
                <Route path="/customers/*" element={<CustomerLayout />} />
                <Route path="/inquiry/*" element={<InquiryLayout />} />
                <Route path="/user_projects/*" element={<UserProjectLayout />} />
                <Route path="/master_profiles/*" element={<MasterProfileLayout />} />
                {/*<Route path="/master_profiles/by_project/:project_id" index element={<MasterProfileLayout />} />*/}
                <Route path="/discovery/*" element={<DiscoveryLayout />} />
                <Route path="/error/not_authorized" element={<NotAuthorized />} />
                <Route path="/navigate" element={<PageNavigation />} />
                <Route path="/reference_page" element={<MainGrid />} />
                <Route path="/dol_profiles/*" element={<DOLProfileLayout />} />

            </Route>

            {/* Public Routes */}
            <Route path="account/*" element={<AccountLayout />} />
            <Route path="/" element={<Navigate to="/account/login" />} />
        </Routes>
    );
}

